import { render } from "./QuestionTab.vue?vue&type=template&id=6fd2809e"
import script from "./QuestionTab.vue?vue&type=script&lang=js"
export * from "./QuestionTab.vue?vue&type=script&lang=js"

import "./QuestionTab.vue?vue&type=style&index=0&id=6fd2809e&lang=scss"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__